import { render, staticRenderFns } from "./VogueDetail.vue?vue&type=template&id=20bbc418&scoped=true&"
import script from "./VogueDetail.vue?vue&type=script&lang=js&"
export * from "./VogueDetail.vue?vue&type=script&lang=js&"
import style0 from "./VogueDetail.vue?vue&type=style&index=0&id=20bbc418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbc418",
  null
  
)

export default component.exports